var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('accessibility-btn',{attrs:{"tabIndex":"0","label":"Close Cart"},on:{"click":function($event){return _vm.closeCart()}}},[_c('div',{staticClass:"close"},[_c('div',{staticClass:"icon-close"})])])}
var staticRenderFns = []

export { render, staticRenderFns }